import React from "react"
import Layout from "../components/Layout"

const Recipes = () => {
  return (
    <Layout>
      <main className="page">
        <h1>Recipes page</h1>
      </main>
    </Layout>
  )
}

export default Recipes
